export default {"src":"/_next/static/media/preloader.22ab487a.gif","height":100,"width":100};